import type { MarketResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMarketListQuery } from "Market/Api/Query/useMarketListQuery";
import { MarketSelectCard } from "Market/Widgets/MarketSelectCard";
import { SettingsPaths } from "Settings/Routes/Routing";
import { Loading } from "Shared/Components/Loading/Loading";
import { Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router";

const orderSetupResource = Resources.base.orderSetup.shared;

export const MarketSelect = () => {
	const { t } = useResource();
	const { data: markets, isLoading } = useMarketListQuery();
	const navigate = useNavigate();

	const handleSelectMarket = (marketId: number) => {
		navigate(SettingsPaths.VerticalSetupVerticalSelect.path(marketId));
	};

	return (
		<>
			<Typography variant="h3">
				{t(orderSetupResource.selectMarketToEdit)}
			</Typography>
			{isLoading && <Loading />}
			<Grid2 container spacing={2} mt={2}>
				{markets?.map((market: MarketResponseDto, index: number) => (
					<Grid2 size={{ xs: 4, sm: 3, md: 2 }} key={market.id}>
						<MarketSelectCard
							market={market}
							index={index}
							onClick={() => {
								handleSelectMarket(market.id);
							}}
						/>
					</Grid2>
				))}
			</Grid2>
		</>
	);
};
